export default "__VITE_ASSET__BoZTX6H6__"